<template>
    <!-- 支付档位 -->
    <div class="half-vip-center">
        <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in h_data_good" :key="index">
                <div @click="clickGoods(item)" :class="{'on':(item.id > 0 && item.id == h_data_goodinfo.id)}" class="slideitem flex_layout flex_flexDirection_column flex_y_start">
                    <div>
                        <div class="i-0" :class="{'opacity0':!getImageIcon(item,'icon')}"><img :src="getImageIcon(item,'icon')"></div>
                        <div class="i-1"><p class="pf-regular">{{item.title}}</p></div>
                        <div class="i-2 flex_layout flex_y_end">
                            <div :class="{android:j_android}" class="i-2-1 flex_layout flex_y_end" v-html="formatHtmlPrice(item)"></div>
                            <div :class="{android:j_android}" class="i-2-2 flex_layout flex_y_end" v-html="formatHtmlPricesub(item)"></div>
                        </div>
                        <div class="i-3" v-html="formatHtmlTip(item)"></div>
                        <div class="i-4" :class="{'opacity0':!getImage(item,'banner')}"><img :src="getImage(item,'banner')"></div>
                    </div>
                </div>
                <div class="arrowhead2" v-if="(item.id > 0 && item.id == h_data_goodinfo.id && visible_arrowhead)"></div>
            </swiper-slide>
        </swiper>
    </div>
</template>
<script>
    //npm模块
    import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import {
        ua,
        getDeepVal,
        fenToYuan,
    } from '@kkmh/utils'
    import {getSelectCouponPrice} from "../js/comp";
    import {doTrackClick} from "../js/track";
    export default {
        components: {
            swiper,
            swiperSlide,
        },
        name: 'GoodsList',
            data () {
            return {
                swiperOption: {
                    // autoplay: true,//可选选项，自动滑动
                    // slidesPerView: 'auto', //5.1,
                    slidesPerView: 3.18, //5.1,
                    // loopedSlides: 4,
                },
                j_android   : ua['android'] ? 1 : 0,
            }
        },
        props: {
            h_visible_hascoupon:false,
            choise_good_num:0,
            h_data_good:{
                type: Array,
                default () {
                    return []
                }
            },
            h_data_goodinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
            j_req:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            visible_arrowhead() {
                let display_type = getDeepVal(this.h_data_goodinfo,'display_info.type','');
                let award_len = getDeepVal(this.h_data_goodinfo,'award_info.award_list',[]).length;
                let vtype = 0;
                if (award_len > 0) {
                    vtype = 1;
                    if (award_len > 2) {
                        vtype = 2;
                    }
                }
                if (display_type == 2) {
                    vtype = 3;
                }
                return vtype > 0 || false;
                // return getDeepVal(this.h_data_goodinfo,'award_info.award_list',[]).length > 0 || false;
            },
        },
        watch: {
            choise_good_num:{
                handler(val, oldVal){
                    this.initSwiper(this.choise_good_num)
                },
                deep:true
            },
        },
        methods:{
            clickGoods(obj) {
                doTrackClick(obj.title, this.j_req);
                this.$emit('clickRealGoods', obj);
            },
            getImageIcon(obj, key){
                if (getDeepVal(obj,'comboinfo.combo_right_icon','')) {
                    return obj.comboinfo.combo_right_icon;
                } else {
                    return this.getImage(obj, key);
                }
            },
            getImage(obj, key){
                let v = obj.image_info ? obj.image_info : {};
                return v[key] ? v[key] : '';
            },
            getPrice(obj, key){
                let v = obj.member_good_price ? obj.member_good_price : obj.price ? obj.price : {};
                return v[key] ? v[key] : 0;
            },
            formatHtmlPrice(item){
                let couponprice  = getSelectCouponPrice(item);
                couponprice = this.h_visible_hascoupon ? couponprice : 0;
                if (this.getPrice(item,'real_price')) {
                    item.curprice = this.getPrice(item,'real_price') - couponprice;
                    return '<span class="pf-regular">￥</span><span class="pf-semibold">'+fenToYuan(item.curprice)+'</span>'    
                }
            },
            formatHtmlPricesub(item) {
                let couponprice  = getSelectCouponPrice(item);
                if (couponprice > 0 && this.h_visible_hascoupon) {//iap支付不能显示优惠券
                    return '<span class="price-sub-icon pf-regular">¥</span>'+
                           '<span class="price-sub decoration pf-regular">'+fenToYuan(this.getPrice(item,'real_price'))+'</span>';
                } else if (this.getPrice(item,'mark_price') > this.getPrice(item,'real_price'))  {
                    return '<span class="price-sub-icon pf-regular">¥</span>'+
                           '<span class="price-sub decoration pf-regular">'+fenToYuan(this.getPrice(item,'mark_price'))+'</span>';
                }
            },
            //
            formatHtmlTip(item) {
                let couponprice  = getSelectCouponPrice(item);
                if (couponprice > 0 && this.h_visible_hascoupon) { //iap支付不能显示优惠券
                    return '<div class="tip a flex_layout flex_xy_center"><span class="pf-regular">已抵扣¥'+fenToYuan(couponprice)+'</span></div>';
                }
                if (this.getWord(item,'discount_tips')) {
                    return '<div class="tip b flex_layout flex_xy_center"><span class="pf-regular">'+this.getWord(item,'discount_tips')+'</span></div>';
                }
                if (item.description) {
                    return '<div class="tip c flex_layout flex_xy_center"><span class="pf-regular">'+item.description+'</span></div>';
                }
            },
            getWord(obj, key){
                let v = obj.words_info ? obj.words_info : {};
                return v[key] ? v[key] : '';
            },
            initSwiper(num){
                this.$nextTick(() => {
                    if (this.swiper.slides.length) {
                        this.swiper.update();
                        this.swiper.slideTo(num, 1000, false);
                        return null;    
                    }
                });
            },
        },
    }
</script>
<style lang="scss">
@import "../../../assets/styles/mixins.scss";
.half-vip-center{
    .i-2 {
        position:absolute;left:vws(16px);top:vws(60px);
        .i-2-1.android {
            span:first-child{margin-bottom: 0;line-height:vws(20px);}    
            span:last-child{line-height: vws(32px);}
        }
        .i-2-1{
            color:#000;height: vws(58px);
            span:first-child{margin-bottom: vws(-3px);font-size: vws(26px);line-height:vws(20px);}
            span:last-child{font-size:vws(52px);line-height: vws(36px);}
        }
        .i-2-2.android{margin: 0 0 vws(4px) vws(8px);}
        .i-2-2{
            margin: 0 0 vws(3px) vws(8px);font-size:vws(40px);line-height:vws(16px);color: rgba(0,0,0,.4);text-decoration: line-through;transform: scale(.5);-webkit-transform: scale(.5);transform-origin: left bottom;-webkit-transform-origin: left bottom;
            span:first-child{}
            span:last-child{}
        }
    }
    .i-3{
        position:absolute;left:vws(16px);top:vws(132px);
        .tip.a {border: 1px solid rgba(255,79,0,0.10); background: #FFFFFF;color: #FF4F00;}
        .tip.b {border: 1px solid #F0EDF6;background: #FFFFFF;color: #B2B4C4;}
        .tip.c {border: 1px solid #F0EDF6;background: #FFFFFF;color: #999;}
        .tip{
            background:#fff;height: vws(46px);border-radius: vws(28px);transform: scale(.75);transform-origin: left bottom;
            span{font-size: vws(24px);white-space: nowrap;padding: 0 vws(16px);}
        }
    }
}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.half-vip-center{
    margin-left:vws(16px);
    .swiper-container{
        overflow:visible;
    }
    .swiper-slide {
        padding-right:vws(16px);
        .slideitem{position: relative;padding-left:vws(16px);position:relative;width:vws(222px);height:vws(282px);overflow: hidden;background: #F9F6FF;border-radius: vws(8px);}
        .slideitem.on{background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAAEaCAMAAABJtxmTAAAAolBMVEUAAAClRP93Kv+tVP+qSv9+Mf+BOv+yW/+JRv+0YP+MS/+0Yf+yXf+IRv+LS/+1Yv+MTf+NS/////+iO/9vIP9+J/+cN/96Jf+UM/9yIf93JP+fOf+ZNv91I/+XNf+ML/+QMf+BKf+DKv+SMv+FK/+JLv+OMP+ILf+GLP/69f/u4P/jzP+6bf/28f/HqP+FQP+ILv/asf+XXP+WW/+TVv/asv9WEcboAAAAEnRSTlMA/f36HBz02tq/v4RdXYSHh4Tw1WieAAADmklEQVR42uzUwaqDMBSE4YiCiIVChCBEEiFEqO2mi/v+r3aP4sJXmOn8K7cfc4y76sa+bSaKmrYfO3evGyayhhvwQbLbvebhrp6T9fnbX56i1/79TNbz2s4+27en6t0a6tyva2w6kuFuE9qATWe8wbaj05nP9htsvClOZJd53afBOjfaaXrKPnEaXR/j11P2jbF3dqK7p2yPsXVNjIQPy9ErxsbFGD1pRhMPNvGQEw858ZATD7mDF8QDLcTgQgieNONRrxe41xMPOPGQEw858ZATD7kf4C3cPOL1lrAwr0fOC0twy7J40sh5RhMPNvGQEw858ZBj5yVqXlqSSyl50k4e+XrigXY+Lbz/nvGon5bE/XKKB5x4yImH3Jxml+bZk3bwZt710pyo15ttPfFAEw858ZATDznxkBMPuV/gleJJO3iFeL1CvV6ZiyvEvCIebuIhJx5y4iG3ris1rxhvXT1px3orMa9w88jXEw848ZATD7mTt22eNHLetm5uI+Zt4uEmHnLiIXfycvaksa+XqXl5yy7zHmfO3DytB5x4yImHnHjInbxaPWk1V1e516vE69UqHmziISfeP7t0kOJADMRQtMgiZDtFjCmDFzYe7GQRmrn/4SbuW0itf4OHhNwVeHM6aeS8+Ttt8p7zmAcz71yP+Jxz2kHMO+jXEw+1k7eWk7Z5i3i9RX3ONZct3nN+ecznZF9vca+3+Nfj5Y01bPDy1ljMvHO9MZy0McTDTTzkxEPuArwuHmh9dOu9O2lfGvV6nX898UATDznxkGu9WePl9d6Zeed6rTlprXGfs3X69cQDTTzkxENu8xIxL3Hz9nopOWlfmjViXkvs64mHmnjIiYeceMiJh5x4yImHnHjI5ZSZeVdYL2cnbfMy73opJ8vE6+UsHmziIScecuIhJx5y4iFHziu5WC7FSdvrFd71csnM6+1zFmJeEQ838ZATDznxkBMPuVqqVV7eBdYrtTpp7Oes9OesxOes3DytB5x4yImHHDsvuHl7vQgnLSIsuNcL8vXEA0085MRDTjzkxENu824RL6fsFXGze8TbKXtH3O0R8XHKPhEP+3k+/5yy/+7q6ARCGAjC8BBYkUCCyP+yJZwhBk77r+0OUbCG/ToYZmC+eJW509aAmrublPHR13D6gCzJEpzh8vUTkumvACPYPtsAii6LA8e+Bfm/z7YfgC+6lUQ4qUgPy04onk1vVucpSIdpmusT7gcV6XsivxmHbgAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;}
    }
    .i-0{
        position: absolute;left:0;top: 0px;width: 100%;height: vws(40px);overflow: hidden;
    }
    .i-1{
        position: absolute;left: vws(16px);top: vws(32px);font-size: vws(26px);color:#333;
        p{
            white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: vws(200px);
        }
    }
    .i-4{position: absolute;top: vws(188px);left: 0;width: 100%;overflow: hidden;}
    .arrowhead{
        position: absolute;
        left: 50%;
        bottom: vws(-21px);
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border: vws(14px) solid transparent;
        border-bottom: vws(12px) solid #f9f6ff;
    }
    .arrowhead2{
        position: absolute;
        left: 50%;
        bottom: vws(-40px);
        transform: translateX(-50%);
        width: vws(56px);
        height: vws(28px);
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA2CAYAAAAf4R06AAAEIUlEQVR4Xu3ax3bbRhQG4P/SB8CQr+EHyCL77LP3xr1XuXdbLnHvTZZ7lZ3yEN7kZZJH4ICDaP4c+9A+iCwGIIkyA0FbzNy583+65CElQfvjdQLidfcjmjeGP8oifiawGkAEwd8d4M9VET6JyKBJd24UoDH8AYuYI/HTCKS/RDAbdmWhKYiNAfxnwDXW4gOJbhaOCF4GCvtEZDFrrevPGwE46HOtCD6SWJU3cBH8EShs9B3Re8CB5jrBl8nLjfcVWQS/BwqbfEb0GnCguV6AhUnwUoi/BQqbfUX0FrAIvCWInyfR5n0JdmWdl4ADzQ3DyesUFaQIfh1OoleI3gEazY0A3pMoDC81iR8DhS0+TaJXgGXi+YroDaDR3ATgXRmTt/RlWAQfAoWtPkyiF4BGczOAt1XgpSZxIVDY5jqi84BGcwuAN1XipRDfBwrbXUZ0GrBOPF8QnQU0mlsBvK5j8pZ5T3wXKOxwcRKdBDSa2wC8cgEvNYlvh4gs6rNnEXWcAzSa24d4zvUmgjeBwk4RcQbRqZBcxktNolOIzgAazR0AXpJwpqdRL3EieB0o7HJhEp0Iy2juBPDCB7zUJL4KFHbXjVg7oIm5C8Rzn/BSiJ//sr+nTsRaAX3GcwWxNkATczeIZz5O3jKfE18ECnvrmMRaAE3MPSCeNgEvNYnPh/8oVelHjMoBTcy9IJ40CS+F+CxQmKlyEisFbDJeXYiVAZqY+0DMN3HyvntPBJ6GPZkp4quyrBqVAJqYM7SYz2qmSc8FeBL2ZH/Zdyod0MTcT4vHZV/ExfoCzIc9OVBmb6UCrmS8b++JJSOWBmhiHqDFXJm/fb7UFuBx2JODZfRbCqCJeZAWj8po2NeaAsyFPTlUdP+FA5qYh2jxsOhGm1BPgEdhTw4XeZdCAU3Mw7R4UGSDTaslwMOwJ0eKuldhgC1efpIiEQsBNDGP0OJ+/iu0KwV4EPbk6LRJTA2Y9HnUAvembWQl7pcO7odKjk1z96kAkz6PWeDuNA2s9L3Swb1QyfFJc5gYMOnzuAXuTHpwuy+VQAd3IyUnJslkIsAWb5KoM/ZMiDg2YNLnCQvcLuEKbckO7kRKTo4TxFiASZ8nLXBrnAPatWMm0MHtSMmpvLtyAyZ9nrLAzbyF23VTJNDBrUjJ6TwVcgEmmqctcSNPwXZNQQkIbkZdOZNVLROwxcuKsMTnORD/FzDRPGOJ6yW22JbOSkBwI+rK2VHLRgImmmctcS2rfvu8ggQE16OuzC530rKAieasJa5W0Fp7RN4EBNeirpxbuvw7wETznCWu5K3brqswAcHVqCvn0yf+BzDRPG+JyxW21B41bgKCK1FXLnzd9g2wxRs3yRrXpxC/ACaaFyxxqcaW2qPHTUBwOerKRUk0L1ril3H3t+sdSEBw6V/RLpC1gW8fDQAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;
        background-size:contain;
        
    }
}
</style>




// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/GoodList.vue